// <<<<<<< Updated upstream
import React, { useRef, useState } from 'react'
import { Box, Toolbar } from '@mui/material'
import { LegacyV1 } from '../../svgIcons/LegacyV1'
import PendingTransactions from '../PendingTransactions'
import ConnectWallet from '../ConnectWallet'
import LogoImage from '../../images/logo/logo_desktop.svg'
import MobileLogo from '../../images/logo/mobileLogo.png'
import { useNavigate } from 'react-router'
import PrimaryButton from '../PrimaryButton'
// import { OutgoingLinkIcon } from '../../svgIcons/OutgoingLink'
import { Link } from 'react-router-dom'
import { MoreDotsIcon } from '../../svgIcons/MoreDotsIcon'
import { StarknetLogoIcon } from '../../svgIcons/StarknetLogoIcon'
import { useOnClickOutside } from '../../hooks/useClickOutside'

function Header(props: { selectedTab: any; onWalletConnected?: any; onWalletDisconnected?: any; className: any }) {
    const { selectedTab, onWalletConnected = () => null, onWalletDisconnected = () => null, className } = props
    const logo = LogoImage
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    // const logo = isMobile ? LogoMobileHeade : LogoImage
    const navigate = useNavigate()
    const menuRef = useRef(null)
    useOnClickOutside(menuRef, () => {
        setIsMenuOpen(false)
    })
    function renderNavigation() {
        return (
            <>
                <span
                    onClick={() => navigate('/swap')}
                    className={`cursor-pointer ml-[50px] mr-[44px] px-2 py-1 ${selectedTab === 'swap' ? 'font-bold bg-[#0C3F6D] rounded-xl' : ''}`}>
                    Swap
                </span>
                <span
                    onClick={() => navigate('/positions')}
                    className={`cursor-pointer mr-[44px] px-2 py-1 ${selectedTab === 'pools' ? 'font-bold  bg-[#0C3F6D] rounded-xl' : ''}`}>
                    Pools
                </span>
                <Link to='/leaderboard?page=1' className={`cursor-pointer mr-[44px] px-2 py-1 ${selectedTab === 'leaderboard' ? 'font-bold  bg-[#0C3F6D] rounded-xl' : ''}`}>
                    <span className='cursor-pointer flex items-center'>Leaderboard</span>
                </Link>
                <Link to='/charts'>
                    <span className={`cursor-pointer flex items-center mr-[44px] px-2 py-1 ${selectedTab === 'charts' ? 'font-bold  bg-[#0C3F6D] rounded-xl' : ''}`}>
                        Charts
                        {/* <OutgoingLinkIcon className='ml-2 w-5 h-5 text-white' /> */}
                    </span>
                </Link>
                <Link to='/rewards' className={`flex px-2 py-1 items-center ${selectedTab === 'rewards' ? 'font-bold  bg-[#0C3F6D] rounded-xl' : ''}`}>
                    <StarknetLogoIcon className='w-[24px] h-[24px] mr-1' />
                    <span className={`cursor-pointer flex items-center  `}>Rewards</span>
                </Link>
                {renderMenu()}
            </>
        )
    }

    function renderMenu() {
        return (
            <div className='flex lg:hidden relative mr-2 lg:mr-0'>
                <div ref={menuRef} className='relative'>
                    <MoreDotsIcon onClick={() => setIsMenuOpen(!isMenuOpen)} className='rotate-90 cursor-pointer w-[24px] h-[24px]' />
                    {isMenuOpen ? (
                        <div className='absolute text-[16px] right-0 top-[36px] w-[180px] bg-[#242C58] text-sm text-gray-100 rounded-md p-3 z-[100]'>
                            <div className='flex items-center'>
                                <LegacyV1 className='w-5 h-5 mr-1 lg:mr-2' />
                                <span onClick={() => window.location.replace('https://v1.myswap.xyz')} className={`text-[16px] cursor-pointer flex items-center px-2 py-1 `}>
                                    Use V1
                                </span>
                            </div>
                            {/* <Link className='flex items-center' to='/rewards'>
                                <StarknetLogoIcon className='w-5 h-5 mr-1 lg:mr-2' />
                                <span className={`text-[16px] cursor-pointer flex items-center px-2 py-1 `}>Rewards</span>
                            </Link> */}
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
    return (
        // <div className='w-full'>
        <div
            className={`${className} rounded-[16px] Header bg-[#272756]`}
            style={{
                background: 'linear-gradient(119deg, rgba(22, 70, 130, 0.34) 0.86%, rgba(0, 45, 160, 0.14) 100%)',
                // background: 'linear-gradient(176deg, rgba(104, 236, 242, 0.50) -50.08%, rgba(60, 78, 172, 0.50) 127.02%)',
                boxShadow: '0px 3px 7px 0px rgba(28, 28, 34, 0.33)'
            }}>
            {/* <div className='container m-auto'> */}
            <div>
                <Toolbar
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        px: 2
                    }}>
                    <Box className='flex flex-1'>
                        <img src={logo} alt='' className='hidden lg:flex w-[70px] lg:w-[150px]' />
                        <img src={MobileLogo} alt='' className='lg:hidden w-[34px] lg:w-[34px]' />
                        <div className='hidden lg:flex items-center text-[18px]'>{renderNavigation()}</div>
                    </Box>
                    <div className='flex items-center'>
                        <PrimaryButton size='sm' className='hidden lg:flex h-[28px] lg:h-[34px] mr-2 lg:mr-4' onClick={() => window.location.replace('https://v1.myswap.xyz')}>
                            <>
                                <LegacyV1 className='w-5 h-5 mr-1 lg:mr-2' />
                                <span className='lg:hidden flex text-[14px]'>V1</span>
                                <span className='hidden lg:flex text-[14px]'>Use V1</span>
                            </>
                        </PrimaryButton>
                        <PendingTransactions />
                        <ConnectWallet connected={onWalletConnected} disconnected={onWalletDisconnected} />
                        <div className='lg:hidden'>{renderMenu()}</div>
                    </div>
                </Toolbar>
            </div>
            {/* </div> */}
        </div>
        // </div>
    )
}

export default Header
